var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "appConversasStatus" } },
    [
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("p", { staticClass: "bolder" }, [_vm._v("Filtros")]),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c(
                "el-col",
                { attrs: { xs: 12, lg: 7, xl: 7, sm: 10 } },
                [
                  _c("InputEntreDatas", {
                    attrs: {
                      placeholder: "Período",
                      calendario: _vm.calendario
                    },
                    model: {
                      value: _vm.calendario,
                      callback: function($$v) {
                        _vm.calendario = $$v
                      },
                      expression: "calendario"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 9, xl: 8, sm: 13 } },
                [
                  _c("p", [_vm._v("Assunto")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "24rem" },
                      attrs: {
                        filterable: "filterable",
                        clearable: "clearable",
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.filtro.assunto,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "assunto", $$v)
                        },
                        expression: "filtro.assunto"
                      }
                    },
                    _vm._l(_vm.assuntos, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8, xl: 8, sm: 12 } },
                [
                  _c("p", [_vm._v("Responsável")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.idsResponsaveis,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "idsResponsaveis", $$v)
                        },
                        expression: "filtro.idsResponsaveis"
                      }
                    },
                    _vm._l(_vm.responsaveis, function(item) {
                      return _c("el-option", {
                        key: item.pessoa.pessoaFisica.id,
                        attrs: {
                          label: item.pessoa.pessoaFisica.nome,
                          value: item.pessoa.pessoaFisica.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin float" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "medium", round: "round" },
                  on: { click: _vm.handleLimpar }
                },
                [_vm._v("Limpar")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", round: "round" },
                  on: { click: _vm.handleFiltrar }
                },
                [_vm._v("Filtrar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "content-dados", attrs: { id: "graficoId" } },
        [
          _vm.acaoCondicao
            ? _c("GraficoStatus", { attrs: { dadosLabels: _vm.dadosFiltro } })
            : _c("app-listagem-conversas", {
                attrs: {
                  data: _vm.dadosFiltro,
                  colunaChave: _vm.nomeColuna,
                  totalDeConversas: _vm.totalDeConversas,
                  emptyData: "Não há dados registrados"
                }
              })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("BotaoSelecionar", {
            staticClass: "center",
            attrs: { botao0: "Gráficos", botao1: "Tabela" },
            on: {
              "btn-0": function($event) {
                return _vm.selecionar("acao-1")
              },
              "btn-1": function($event) {
                return _vm.selecionar("acao-2")
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "botao-exportar float" },
        [
          _c("BotaoExportarSelecionado", {
            attrs: {
              dadosFiltro: _vm.filtro,
              selecionadoCondicao: _vm.acaoCondicao,
              disabled: _vm.botaoExportarDesligado,
              tab: "status",
              carregando: _vm.isLoading
            },
            on: { "exportar-img-grafico": _vm.exportarImgGrafico }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-753a50d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-753a50d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/components/conversas/AppConversasStatus.vue
// module id = null
// module chunks = 